import typeMatch from "./typeMatch"

const editCruiseStopLink = (stop, cruisePlanId) => {
  const type = typeMatch(stop.type, {
    reservation: () => "reservation",
    marina: () => "marina",
    location: () => "location",
    note: () => "note",
  })
  return `/account/cruise_plans/${cruisePlanId}/cruise_stops/${type}_stops/${stop.id}/edit`
}

export default editCruiseStopLink
